import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ObservableDataLoader } from '@bsquare/angular-common';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DATA_LOADER_CONFIG } from './observable-data-loader-config';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly httpClient = inject(HttpClient);

  private readonly versionLoader = new ObservableDataLoader<string>((key) => {
    // TODO Bug in this version of Angular means responseType text is missing from
    // the type definitions.
    return this.httpClient.get<string>(key, {
      responseType: 'text',
    } as any) as unknown as Observable<string>;
  }, DATA_LOADER_CONFIG);

  public get version(): Observable<string> {
    return this.versionLoader.load('/version').pipe(
      catchError(() => {
        return of('dev');
      }),
    );
  }
}
